import React, { useMemo, useState } from 'react';
import { ALL_GROUPS } from '../../../types';
import { useFilter } from '../../../FilterContext';
import MobileFilterTriggerBar from './MobileFilterTriggerBar';
import MobileGroupDrawer from './MobileGroupDrawer';
import MobileSortViewDrawer from './MobileSortViewDrawer';

const MobileFilterBar: React.FC = () => {
    const {
        channelGroupsWithChannels,
        selectedGroupId,
        setSelectedGroupId,
        sortType,
        setSortType,
        typeFilter,
        setTypeFilter,
    } = useFilter();
    const [isGroupDrawerOpen, setIsGroupDrawerOpen] = useState(false);
    const [isSortDrawerOpen, setIsSortDrawerOpen] = useState(false);
    const [pendingSortType, setPendingSortType] = useState(sortType);
    const [pendingTypeFilter, setPendingTypeFilter] = useState(typeFilter);

    const openSortDrawer = () => {
        setPendingSortType(sortType);
        setPendingTypeFilter(typeFilter);
        setIsSortDrawerOpen(true);
    };

    const applySortAndFilter = () => {
        setSortType(pendingSortType);
        setTypeFilter(pendingTypeFilter);
        setIsSortDrawerOpen(false);
    };

    const selectedGroupLabel = useMemo(() => {
        if (selectedGroupId === ALL_GROUPS) {
            return 'All';
        }

        return (
            channelGroupsWithChannels.find(
                (group) => group._id === selectedGroupId
            )?.name || 'All'
        );
    }, [channelGroupsWithChannels, selectedGroupId]);

    return (
        <>
            <MobileFilterTriggerBar
                selectedGroupLabel={selectedGroupLabel}
                onOpenGroup={() => setIsGroupDrawerOpen(true)}
                onOpenSort={openSortDrawer}
            />
            <MobileGroupDrawer
                open={isGroupDrawerOpen}
                onClose={() => setIsGroupDrawerOpen(false)}
                channelGroupsWithChannels={channelGroupsWithChannels}
                selectedGroupId={selectedGroupId}
                onSelectGroupId={setSelectedGroupId}
            />
            <MobileSortViewDrawer
                open={isSortDrawerOpen}
                onClose={() => setIsSortDrawerOpen(false)}
                sortType={pendingSortType}
                onSelectSortType={setPendingSortType}
                typeFilter={pendingTypeFilter}
                onSelectTypeFilter={setPendingTypeFilter}
                onDone={applySortAndFilter}
            />
        </>
    );
};

export default MobileFilterBar;
